module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-down-gray-medium-68b0378c77dbc347dbc5375bbdda4073.svg";